import { NgModule } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { LayoutEmptyComponent } from '../common/components/layout-empty/layout-empty.component';
import { LayoutDefaultComponent } from '../common/components/layout-default/layout-default.component';
import { LayoutEmbeddableComponent } from '../common/components/layout-embeddable/layout-embeddable.component';
import { UserAuthGuard } from '../user/guards/user-auth-guard';
import { PermissionGuard } from '../../core/guards/permission.guard';

@NgModule({
  providers: [
    provideRouter([
      {
        path: 'customers',
        component: LayoutDefaultComponent,
        canActivate: [UserAuthGuard, PermissionGuard],
        data: { permissions: 'GET_CUSTOMERS' },
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/customers/customers.component').then((x) => x.CustomersComponent),
          }
        ]
      },
      /**
       * The customer detail view as a directly-linkable page:
       *   /customers/C00001000?profileId=APS&tab=info&displayHeader=false&displayFooter=false
       *
       * A sibling of the grid route rather than a child of it, so the grid is not loaded and
       * left running behind an embedded page. `LayoutEmbeddableComponent` makes the Freely
       * header and footer optional; the guards are the SAME as the grid's — hiding the chrome
       * does not make a customer public, and an embedding host still needs a signed-in session.
       */
      {
        path: 'customers/:customerId',
        component: LayoutEmbeddableComponent,
        canActivate: [UserAuthGuard, PermissionGuard],
        data: { permissions: 'GET_CUSTOMER' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/customer-detail/customer-detail.component').then(
                (x) => x.CustomerDetailPageComponent
              ),
            // Unsaved Customer Info edits must be saved or discarded before leaving the page.
            canDeactivate: [
              (page: { canDeactivate?: () => Promise<boolean> }) => page?.canDeactivate?.() ?? true,
            ],
          },
        ],
      },
    ], withComponentInputBinding()),
  ]
})
export class CustomerRoutingModule { }
